<template>
  <div class="container">
    <Tbheader :tipo="tipo + ' - Serviços'" :novo="novo" :titulo="contentEdit.titulo" :icone="icone" />
    <form class id="feedback-form" @submit="formSubmit" method="post">
      <div class="row">
        <div class="col-8 form-group">
          <label>Título:</label>
          <input
            type="text"
            v-model="contentEdit.titulo"
            name="titulo"
            id="titulo"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-2 form-group">
          <label>Abreviação:</label>
          <input
            type="text"
            v-model="contentEdit.abreviacao"
            name="abreviacao"
            id="abreviacao"
            class="form-control required valid"
            value
          />
        </div>
        <div class="col-md-2 form-group">
          <label>Ativo:</label>
          <div class="btn-group btn-group-toggle d-flex" data-toggle="buttons">
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="ativo"
              :class="{'active': contentEdit.ativo == true}"
            >
              <input type="radio" name="ativo" id="ativo" @change="fnAtiva() " :value="true" autocomplete="off" class="valid" /> Sim
            </label>
            <label
              class="btn btn-outline-secondary ls0 nott"
              id="inativo"
              :class="{'active': contentEdit.ativo == false}"
            >
              <input type="radio" name="ativo" id="inativo"  @change="fnAtiva()"  :value="false" autocomplete="off" class="valid" /> Não
            </label>
          </div>


        </div>
        <div class="col-sm-12">
          <hr>
          <h5>Preço para até 12 colaboradores incluindo o diretor e gerente</h5>
        </div>
        <div class="col-2 form-group">
          <label> Preço:</label>
          <vue-numeric  class="form-control required valid" 
          v-model="contentEdit.preco1Ate"></vue-numeric>
        </div>
        <div class="col-2 form-group">
          <label>Contratação :</label>
          <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco1Contratacao"></vue-numeric>

        </div>
        <div class="col-3 form-group">
          <label>Contratação parceiro:</label>
          <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco1ContratacaoParceiro"></vue-numeric>
        </div>
        <div class="col-2 form-group">
          <label>Renovação:</label>
           <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco1Renovacao"></vue-numeric>
        </div>        
        <div class="col-3 form-group">
          <label>Renovação parceiro:</label>
           <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco1RenovacaoParceiro"></vue-numeric>
        </div>
        <div class="col-sm-12">
          <hr>
          <h5>Preço de 13 a 30 colaboradores incluindo o diretor e gerente</h5>
        </div>

        <div class="col-2 form-group">
          <label>(2) Preço:</label>
          <vue-numeric  class="form-control required valid" 
          v-model="contentEdit.preco2Ate"></vue-numeric>
        </div>
        <div class="col-2 form-group">
          <label>Contratação :</label>
          <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco2Contratacao"></vue-numeric>

        </div>
        <div class="col-3 form-group">
          <label>Contratação parceiro:</label>
          <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco2ContratacaoParceiro"></vue-numeric>
        </div>
        <div class="col-2 form-group">
          <label>Renovação:</label>
           <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco2Renovacao"></vue-numeric>
        </div>        
        <div class="col-3 form-group">
          <label>Renovação parceiro:</label>
           <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco2RenovacaoParceiro"></vue-numeric>
        </div>
        <div class="col-sm-12">
          <hr>
           <h5>Preço de 31 pra cima incluindo o diretor e gerente</h5>
       </div>

        <div class="col-2 form-group">
          <label>(3) Preço:</label>
          <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco3Contratacao"></vue-numeric>

        </div>
        <div class="col-3 form-group">
          <label>Contratação parceiro:</label>
          <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco3ContratacaoParceiro"></vue-numeric>
        </div>
        <div class="col-2 form-group">
          <label>Renovação:</label>
           <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco3Renovacao"></vue-numeric>
        </div>        
        <div class="col-3 form-group">
          <label>Renovação parceiro:</label>
           <vue-numeric currency="R$" class="form-control required valid" v-bind:precision="2" separator="." 
          v-model="contentEdit.preco3RenovacaoParceiro"></vue-numeric>
        </div>
        <div class="col-sm-12">
          <hr>
        </div>

       <div class="col-sm-12">
            <h4 class="mb-3">Texto de contrato</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoContrato" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoContrato =''">Limpar</button>
        </div>       

        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 01</h4>
          <vue-editor :editor-toolbar="customToolbar" class="textoAjuda01" v-model="contentEdit.textoAjuda01" />
          <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda01 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 02</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda02" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda02 =''">Limpar</button>
       </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 03</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda03" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda03 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 04</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda04" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda04 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 05</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda05" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda05 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 06</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda06" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda06 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 07</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda07" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda07 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 08</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda08" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda08 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 09</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda09" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda09 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 10</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda10" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda10 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 11</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda11" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda11 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 12</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda12" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda12 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
            <h4 class="mb-3">Ajuda Etapa 13</h4>
          <vue-editor :editor-toolbar="customToolbar" v-model="contentEdit.textoAjuda13" />
           <button type="button" class="btn btn-primary mb-3 mt-2" @click.prevent="contentEdit.textoAjuda13 =''">Limpar</button>
        </div>
        <div class="col-sm-12">
          <hr />
        </div>
        <!--
        <div class="col-3 form-group">
          <small>Criado em:</small>
          <small v-if="contentEdit.tsInclusao">
            <b>{{formatData(contentEdit.tsInclusao)}}</b>
          </small>
        </div>
        -->
        <div class="col-3 form-group"  >
          <small>Alterado em:</small>
          <small v-if="contentEdit.tsAlteracao">
             <b>{{formatData(contentEdit.tsAlteracao)}}</b>
          </small>
        </div>
        <div class="col-6 ml-auto text-right">
          <button
            type="button"
            name="cancelar"
            class="btn btn-danger btn-md"
            @click="fnCancela()"
          >Cancelar</button>
          <button
           type="submit"
            name="feedback-form-submit"
            class="btn btn-success ml-3"
          >Gravar</button>
        </div>
      </div>
    </form>
    <div>{{temErro}}</div>
  </div>
</template>

<script>
import Tbheader from "../_include/_headerTabelas";
import { getData,getSuccess,getError } from "../../global/utils";
import { VueEditor } from "vue2-editor";
export default {
  props: ["id"],
  data() {
    return {
      novo: true,
      tipo: "",
      icone: "",
      urlApi: "",
      suporteAtivo: true,
      success: false,
      error:null,
      contentEdit: {
        titulo:'',
        ativo: false
      },      
      customToolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["blockquote"],
      ["clean"]
    ]

    };
  },
  components: { Tbheader,VueEditor  },
  methods: {
    fnLimpa(){
      this.contentEdit.titulo = ''
      this.contentEdit.ativo = ''
    },
    fnLimpaConteudo(classe){
      var element = document.getElementsByClassName(classe);
      element[0].innerHTML = "";
    },
    fnicone() {
      this.icone = this.novo ? "icon-line2-plus" : "icon-line-edit";
    },
    fnAtiva() {
          this.contentEdit.ativo = !this.contentEdit.ativo
    },
    fnCancela(){
        this.$router.push({path: "/paineldegerenciamento/servicos"})
    },
    async formSubmit(e) {
        e.preventDefault();
        const metodo = this.$route.params.id ? 'put' : 'post'
        this.contentEdit.tsAlteracao = this.$route.params.id ? this.$moment().format() : null
        const completaUrl = this.$route.params.id ? "/" + this.$route.params.id : ''
       let data = await this.$http[metodo]("/servicos" + completaUrl,this.contentEdit)
        .then(() =>{
            getSuccess();
            this.fnLimpa();
            this.fnCancela();
        })
       .catch(e => {
        return  e
        }); 
        this.error = data
        

    },
    fnGetError(e){
      getError(e)
    },
    fnIsEdit() {
      if (this.$route.params.id != undefined && this.$route.params.id != "") {
        this.tipo = "Editando";
        this.novo = false;
        this.fnCarregaItems(this.$route.params.id)
      } else {
        this.tipo = "Incluindo";
        this.novo = true;
        this.contentEdit.ativo = false
      }
      this.fnicone();
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY HH:MM");
    },
    async fnCarregaItems(valueId) {
      let data = await getData(this.urlApi+"/servicos/"+valueId);
      this.contentEdit = data[0].content;
      this.$vs.loading.close()
    },   
  },
  created() {
    this.fnIsEdit();
  },
  computed: {
    confere: function(){
      return this.fnIsEdit()
    },
    temErro(){
      if (this.error){
         return this.fnGetError(this.error)
      }else{
        return ''
      }
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>

</style>